import React, { useState, useRef, useEffect, useMemo, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { FormControl, MenuItem } from 'react-bootstrap';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import PropTypes from 'prop-types';

import { isTouchDevice } from '../../../../../utils/helper';

const Menu = forwardRef(({ onSelectReply, onToggleClose, open, rootCloseEvent, replies }, ref) => {
  const inputRef = useRef(null);

  const [searchValue, setSearchValue] = useState('');

  const handleChange = (e) => setSearchValue(e.target.value);

  const onSelect = (reply) => {
    onSelectReply && onSelectReply(reply);
    onToggleClose();
  };

  const handleFocus = () => {
    if (isTouchDevice() === false) {
      return inputRef?.current?.focus();
    }
  };

  const filteredReplies = useMemo(() => {
    if (!searchValue) return replies;

    return replies.filter((reply) => (reply.body + reply.title).toLowerCase().replace(/\s/g, '').includes(searchValue.toLowerCase().replace(/\s/g, '')));
  }, [searchValue, replies]);

  const onRootClose = () => {
    onToggleClose();
    setSearchValue('');
  };

  useEffect(() => {
    if (open) {
      handleFocus();
    }
  }, [open]);

  return (
    <RootCloseWrapper disabled={!open} onRootClose={onRootClose} event={rootCloseEvent}>
      <div className="dropdown-menu dropdown-menu-right replies-dropdown" onFocus={() => handleFocus()} tabIndex={-1}>
        <li className="search-item">
          <FormControl ref={ref} inputRef={inputRef} type="text" placeholder="Search..." onChange={handleChange} value={searchValue} />
          <Link to="/tickets/saved-replies" className="link-replies">
            <span className="fa fa-cog" />
          </Link>
        </li>
        <ul className="replies-dropdown-list">
          {filteredReplies?.map((reply) => (
            <MenuItem key={reply.id} eventKey={reply} onSelect={onSelect}>
              {reply.title}
            </MenuItem>
          ))}
          {filteredReplies?.length === 0 && (
            <MenuItem className="empty" onClick={() => inputRef?.current?.focus()}>
              No replies
            </MenuItem>
          )}
        </ul>
      </div>
    </RootCloseWrapper>
  );
});

Menu.propTypes = {
  onSelectReply: PropTypes.func,
  replies: PropTypes.array,
  onToggleClose: PropTypes.func,
  open: PropTypes.bool,
  rootCloseEvent: PropTypes.string,
};

export default Menu;
